import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { clearAllExceptAccount } from "src/store/actions";
import CustomModal from "./CustomModal";

function mapStateToProps({ onlineShopper: { subModal } }: ApplicationStore) {
    return {
        message: subModal.message as string,
        refresh: subModal.refresh,
        title: subModal.title as string,
    };
}

const mapDispatchToProps = (dispatch: any) => ({
    refreshDeal: () => {
        dispatch(clearAllExceptAccount());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomModal);
